import { useState, useEffect } from "react";
import {PhoneInputComponent} from "../phoneLogin/PhoneInput";
import { isPhoneValid } from "../../utils/phoneNumber/validation";
import { useDispatch, useSelector } from "react-redux";
import {
    setPhoneNumber,
    updatePhoneNumberInDB,
    clearPhoneNumberError
  } from "../../actions/phoneActions";
import { posthogPhoneNumberEvent } from '../../posthog/phoneNumberEvent';
import { POSTHOG_CAPTURE_PHONE_INVALID_NUMBER } from '../../posthog/constants';

export default function PhoneNumberSection() {
  return (
    <div className="flex flex-col gap-[16px] px-5 pb-10" style={{ borderTop: '1px solid rgba(14, 11, 38, 0.1)', paddingTop: '32px' }}>
        <PhoneNumberHeroSection />
        <PhoneNumberInput />
    </div>
  )
}

const PhoneNumberHeroSection = () => {
    return (
        <div className="flex flex-col gap-[12px] w-full">
            <div className="flex gap-2 justify-between">
                <p className="">🧾 <span className="text-[18px] geomanistMedium text-black ">Recevoir mon justificatif d'achat</span></p>
                <p className="text-[18px] geomanistMedium text-black">*</p>
            </div>
            <div>
                <p className="text-[16px] geomanistBook text-[#4B823D]">En cas de contrôle, présente simplement le SMS !</p>
            </div>
        </div>
    );
};

const PhoneNumberInput = () => {
    const dispatch = useDispatch();
    const phoneState = useSelector((state) => state.phone);
    const cart = useSelector((state) => state.cart);
    const hasError = phoneState?.hasError;
    const reduxPhoneNumber = phoneState?.phoneNumber || '';

    const [isFocused, setIsFocused] = useState(false);
    const orderId = cart?.cartItems?._id;

    const displayValue = reduxPhoneNumber
        ? (reduxPhoneNumber.startsWith('+') ? reduxPhoneNumber.slice(1) : reduxPhoneNumber)
        : '';

    const isPhoneNumberValid = isPhoneValid(reduxPhoneNumber);
    const hasPhoneNumber = reduxPhoneNumber.length > 0;

    const isValid = isFocused || (!hasError && (isPhoneNumberValid || !hasPhoneNumber));
    const displayCheckMark = !isFocused && isPhoneNumberValid && hasPhoneNumber;

    const errorMessage = (() => {
        if (isFocused || isValid) {
            return '';
        }

        if (!hasPhoneNumber) {
            return 'Attention ! Ce champs est obligatoire.';
        }

        if (!isPhoneNumberValid) {
            posthogPhoneNumberEvent(POSTHOG_CAPTURE_PHONE_INVALID_NUMBER,
                                    {
                                        phoneNumber: reduxPhoneNumber,
                                        orderId: cart?.cartItems?._id
                                    })
            return 'Il faut renseigner un numéro valide.';
        }

        return '';
    })();

useEffect(() => {
    const savedNumber = localStorage.getItem('phoneNumber');
    let userPhoneNumber = null;

    try {
        const user = localStorage.getItem('user');
        if (user) {
            userPhoneNumber = JSON.parse(user)?.phoneNumber;
        }
    } catch (error) {
        console.error('Error parsing user:', error);
    }

    if (savedNumber || userPhoneNumber) {
        let numberToUse = savedNumber || userPhoneNumber;

        if (numberToUse.startsWith('+')) {
            numberToUse = numberToUse.slice(1);
        }

        if (numberToUse.startsWith('0')) {
            numberToUse = '+33' + numberToUse.slice(1);
            console.log(`Numéro localStorage normalisé: ${savedNumber || userPhoneNumber} → ${numberToUse}`);
        }
        else if (numberToUse.startsWith('330')) {
            numberToUse = '+33' + numberToUse.slice(3);
            console.log(`Numéro localStorage corrigé (330): ${savedNumber || userPhoneNumber} → ${numberToUse}`);
        }
        else if (/^\d+$/.test(numberToUse)) {
            numberToUse = '+' + numberToUse;
        }

        dispatch(setPhoneNumber(numberToUse));

        if (isPhoneValid(numberToUse) && orderId) {
            dispatch(updatePhoneNumberInDB(numberToUse, orderId));
        }
    }
}, [dispatch, orderId]);

    useEffect(() => {
        if (hasError && !isFocused) {
            const phoneInputElement = document.querySelector('.phone-input-container');
            if (phoneInputElement) {
                phoneInputElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        }
    }, [hasError, isFocused]);

    useEffect(() => {
        if (isFocused && hasError) {
            dispatch(clearPhoneNumberError());
        }
    }, [isFocused, hasError, dispatch]);

    useEffect(() => {
        if (!isFocused && isPhoneNumberValid && orderId) {
            dispatch(updatePhoneNumberInDB(reduxPhoneNumber, orderId));
        }
    }, [isFocused, isPhoneNumberValid, reduxPhoneNumber, orderId, dispatch]);

    const handlePhoneNumberChange = (value, _country) => {
        const fullNumber = value ? `+${value}` : '';
        let normalizedNumber = fullNumber;
        if (_country.countryCode === 'fr') {
          if (fullNumber.startsWith('+330')) {
                normalizedNumber = fullNumber.replace('+330', '+33');
                console.log(`Numéro corrigé: ${fullNumber} → ${normalizedNumber}`);
            }
        }
        dispatch(setPhoneNumber(normalizedNumber));

        const isNumberValid = isPhoneValid(normalizedNumber);

        if (isNumberValid && orderId) {
            dispatch(updatePhoneNumberInDB(normalizedNumber, orderId));
        }

        if (isNumberValid && hasError) {
            dispatch(clearPhoneNumberError());
        }
    };

    const handleFocus = () => {
        setIsFocused(true);
    };

    const handleBlur = () => {
        setIsFocused(false);
    };

    return (
        <div className="flex flex-col gap-[16px]">
            <PhoneInputComponent
                value={displayValue}
                onChange={handlePhoneNumberChange}
                onFocus={handleFocus}
                onBlur={handleBlur}
                defaultCountry="fr"
                isValid={isValid}
                displayCheckMark={displayCheckMark}
            />
                <div className="mt-2 min-h-[20px]">
                <p
                    className="text-[14px] geomanistMedium text-[#E04223] transition-opacity duration-200"
                    style={{ opacity: isValid ? 0 : 1 }}
                >
                    {errorMessage}
                </p>
                </div>
        </div>
    );
};


